import React, { Component } from "react";
import { Animated } from "react-animated-css";
import Navbar from "./Navbar";
import Footer from "./Footer";
import CallUs from "./CallUs";
import Formik from "./Formik";

class ContactUs extends Component {
  render() {
    return (
      <div>
        <Animated
          animationInDelay={100}
          animationIn="bounceInLeft"
          animationOut="bounceInRight"
          isVisible
        >
          <Navbar />
        </Animated>

        <CallUs />
        <Formik />
        <Footer />
      </div>
    );
  }
}

export default ContactUs;
